import { Injectable, OnDestroy } from '@angular/core';
import { SharedCommonUtility } from '@shared/utils/common.utility';
import * as echarts from 'echarts/core';

@Injectable()
export class EchartsService implements OnDestroy {
  private chartInstances: echarts.ECharts[] = [];
  private resizeObserver: ResizeObserver = new ResizeObserver(this.observeResize.bind(this));

  private observeResize(): void {
    window.requestAnimationFrame(() => {
      this.chartInstances.forEach((chart: echarts.ECharts) => {
        chart.resize();
      });
    });
  }

  public initialize(
    element: HTMLElement | null,
    theme?: string | Record<string, unknown>,
    opts?: echarts.EChartsInitOpts,
    chartId?: string,
  ): echarts.EChartsType {
    const chart = echarts.init(element, theme, opts);
    this.chartInstances.push(chart);
    this.resizeObserver.observe(element);

    return chart;
  }

  public disposeAll(): void {
    this.chartInstances.forEach((chart: echarts.ECharts) => {
      chart.dispose();
      if (SharedCommonUtility.notNullish(chart.getDom())) {
        this.resizeObserver.unobserve(chart.getDom());
      }
    });
    this.chartInstances = [];
  }

  public ngOnDestroy(): void {
    this.disposeAll();
    this.resizeObserver.disconnect();
  }
}
